// extracted by mini-css-extract-plugin
export default {"bank":"BankItem_bank__fLl+1","publicBank":"BankItem_publicBank__LYqM5"};